import * as React from "react";

const ImageCarouselPrev: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="48" viewBox="0 0 28 48" fill="none">
            <path
                d="M17.9207 15L19 16.0792L11.2885 23.7892L18.9985 31.5L17.9207 32.5785L9.67075 24.3285L9.1555 23.7892L9.67075 23.25L17.9207 15Z"
                fill="#535353"
            />
        </svg>
    );
};

export default React.memo(ImageCarouselPrev);
